import { OnInit, OnDestroy, Directive, TemplateRef } from '@angular/core';
import { CarouselComponent } from './carousel.component';

@Directive({
  selector: 'carousel-area, [carousel-area]',
  exportAs: 'carouselArea',
  host: {}
})
export class CarouselAreaDirective implements OnInit, OnDestroy {


  constructor(public template: TemplateRef<any>, private carosel: CarouselComponent) { }

  ngOnDestroy(): void {
    this.carosel.removeImage(this);
  }

  ngOnInit(): void {
    this.carosel.addImage(this);
  }
} 
